import FaveBizAPI from 'integrations/FaveBizAPI';
import { GenericSuccessType } from '../types/GenericSuccessType';

export const deactivateEcard = (id: number): Promise<GenericSuccessType> =>
  FaveBizAPI.put(`/v1/e_cards/${id}/deactivate`);

export const deactivateDeal = (id: number, reason: string, note: string): Promise<GenericSuccessType> =>
  FaveBizAPI.put(`/v1/deals/${id}/deactivate`, {reason: reason, note: note})